<template>
  <div>
    <List
      url="auditlogs/"
      :title="title"
      titleClass="title"
      :tanle="tanle"
      :operat="operat"
      :data="searchData"
      :afterList="dealList"
      :update="updateList"
      @detail="detail"
    >
      <div slot="Filter">
        <div style="display: flex;line-height:30px; ">
          <label>操作：</label>
          <el-checkbox-group v-model="action" style="margin-right:165px">
            <el-checkbox
              v-for="operat in operats"
              :label="operat"
              :key="operat"
              :value="operat"
              >{{ operat.Name }}
            </el-checkbox>
          </el-checkbox-group>
          <el-button @click="search" type="primary" size="small"
            >搜索</el-button
          >
        </div>
        <div style="display:flex">
          <div class="item">
            <label>操作人：</label>
            <el-input
              v-model="searchData.actor"
              style="width:200px;"
            ></el-input>
          </div>
          <div class="item">
            <label>对象数据类型：</label>
            <el-input
              v-model="searchData.content_type"
              style="width:200px;"
            ></el-input>
          </div>
        </div>

        <div style="display: flex;">
          <div class="item">
            <label>用户IP：</label>
            <el-input
              v-model="searchData.remote_addr"
              style="width:200px;"
            ></el-input>
          </div>
          <div class="item">
            <label>模糊查询：</label>
            <el-input
              v-model="searchData.search"
              style="width:235px;"
            ></el-input>
          </div>
        </div>
      </div>
    </List>

    <UpdateBox
      :initForm="updateForm"
      :updateType="updateType"
      v-if="updateBlock"
      @close="close"
      @update="updateList++"
    ></UpdateBox>
  </div>
</template>

<script>
import List from "../components/common/List.vue";
import UpdateBox from "../components/LogAudit/UpdateBox.vue";

export default {
  components: {
    List,
    UpdateBox
  },
  data() {
    return {
      tanle: [
        { name: "created", label: "日志生成时间" },
        { name: "actor", label: "操作人" },
        { name: "menu", label: "操作接口" },
        { name: "action", label: "操作" },
        { name: "content_obj", label: "操作对象" },
        { name: "content_type", label: "对象数据类型" },
        // { name: "http_url", label: "URL" },
        // { name: "http_method", label: "HTTP方法" },
        {
          name: "changesName",
          label: "修改内容",
          status: "alarmEvent"
        },
        { name: "remote_addr", label: "用户IP" }
      ],
      searchData: {
        actor: "",
        action: "",
        search: "",
        remote_addr: "",
        content_type: ""
      },
      title: "日志记录",
      operat: [
        {
          text: "Detail",
          eventName: "detail"
        }
      ],
      action: [],
      operats: ["create", "update", "delete", "view"],
      updateBlock: false,
      updateForm: {},
      updateList: 0
    };
  },
  methods: {
    dealList(data) {
      for (let i in data) {
        data[i].changesName = JSON.stringify(data[i].changes);
      }
      return data;
    },
    search() {
      this.searchData.action = this.action.join(",");
      console.log(this.operats);
      this.updateList++;
    },
    detail(val) {
      this.updateBlock = true;
      this.updateType = "detail";
      this.updateForm = Object.assign({}, val);
    },
    close() {
      this.updateBlock = false;
    }
  }
};
</script>
<style>
.item {
  margin: 10px 40px 10px 0px;
  line-height: 30px;
}
</style>
